import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useTranslation } from "react-i18next";
import validator from "validator";
import ReCAPTCHA from "react-google-recaptcha";
import HCaptcha from "@hcaptcha/react-hcaptcha";

import { SocialProvider } from "../SocialProvider";
import { CustomSelectComponent } from "../../common/CustomSelectComponent";
import { MustContainItem } from "../MustContainItem";
import { SignerService } from "../../service/SignerService";
import { IRISService } from "../../service/IRISService";
import { LoadingContent } from "../../common/LoadingContent";
import { trackBusinessEvt } from "../../common/CustomEvents";
import { sha256 } from "../../common/IdentityUtils";
import TextInput from "react-autocomplete-input";
import "react-autocomplete-input/dist/bundle.css";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import { Icon } from "@iconify/react";
import get from "lodash/get";

import classes from "./OnePage.module.css";
import "./UpdatePasswordContainer.css";

var fieldInfo = {};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "contents",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

export const OnePageRegistration = (props) => {
  const { identityConfig, setState, setPosition } = props;
  const { pages, division, brand, language, configureRoles } = identityConfig;
  const google_captcha_key = process.env.GOOGLE_CAPTCHA_KEY;
  const hcaptcha_key = process.env.HCAPTCHA_KEY;
  const { t } = useTranslation();
  const givenNameInputRef = useRef();
  const familyNameInputRef = useRef();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const confirmPasswordInputRef = useRef();
  const recaptchaRef = useRef();
  const hcaptchaRef = useRef();
  const [hcaptchaRes, setHcaptchaRes] = useState("");
  const [showEmailSignInInfo, setShowEmailSignInInfo] = useState(true);
  const [showToggleButton, setShowToggleButton] = useState(true);
  const [userObj, setUserObj] = useState(null);
  const [error, setError] = useState("");
  const [countryType, setCountryType] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordRules, setshowPasswordRules] = useState(false);
  const [errors, setErrors] = useState([]);
  const [emailError, setEmailError] = useState("");
  const [isTypeAConsentSelected, setTypeAConsentSelected] = useState(false);
  const [isTypeDConsentSelected, setTypeDConsentSelected] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [isHuman, setIsHuman] = useState(false);
  const [autoConsent, setAutoConsent] = useState(false);
  const classesMat = useStyles();

  // booleans for password validations
  const [containsUL, setContainsUL] = useState(false); // uppercase letter
  const [containsLL, setContainsLL] = useState(false); // lowercase letter
  const [containsN, setContainsN] = useState(false); // number
  const [containsSC, setContainsSC] = useState(false); // special character
  const [contains8C, setContains8C] = useState(false); // min 8 characters
  const [passwordMatch, setPasswordMatch] = useState(false); // passwords match
  const privacy_policy_text = t("privacy_policy_text");
  const [FP_text, setFPConsentText] = useState("");
  const [fp_consent, setFPConsent] = useState(null);
  const [companyData, setCompanyData] = useState({});

  const [questionSelection, setQuestionSelection] = useState(() => {
    return pages.map((page, index) => {
      return {
        [`page${index + 1}`]: page.questions.map((question) => {
          let profile_id = question.profile_id
            ? question.profile_id
            : question.id;
          const questionObj = {};
          questionObj.id = profile_id;
          if (question.hasOwnProperty("isCompany")) {
            questionObj.isCompany = true;
            questionObj.company_fields = question.company_fields;
          }
          if (question.hasOwnProperty("isRole")) {
            questionObj.isRole = true;
          }
          questionObj[profile_id] = "";
          questionObj["required"] =
            question.required != undefined ? question.required : true;
          questionObj.type = question.type ? question.type : "";
          return questionObj;
        }),
      };
    });
  });

  const [questionData, setQuestionData] = useState({});
  const [filteredQuestionData, setFilteredQuestionData] = useState({});
  const [profilePic, setProfilePic] = useState("");
  const [fullName, setFullName] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [checkedListItems, setCheckedListItems] = useState([]);

  const authToken = useRef(null);
  const userDomain = useRef(null);

  const { cols: gridCols, rows: gridRows } = useMemo(
    () =>
      pages[pageNumber - 1].questions.reduce(
        (res, question) => ({
          rows:
            res.rows > question.layout.rows ? res.rows : question.layout.rows,
          cols:
            res.cols > question.layout.cols ? res.cols : question.layout.cols,
        }),
        { rows: 0, cols: 0 }
      ),
    [pages]
  );

  let orderedQuestions = useMemo(
    () =>
      pages[pageNumber - 1].questions
        .slice()
        .sort((prev, next) =>
          prev.layout.rows !== next.layout.rows
            ? prev.layout.rows - next.layout.rows
            : prev.layout.cols - next.layout.cols
        ),
    [pages]
  );

  // labels and state boolean corresponding to each validation
  const mustContainData = [
    [t("eight_char"), contains8C],
    [t("lower_case"), containsLL],
    [t("upper_case"), containsUL],
    [t("special_char"), containsSC],
    [t("one_number"), containsN],
    [t("passwords_match"), passwordMatch],
  ];


  // code added to handle removing opr from dom 
  useEffect(() => {
    const handleLocationChange = () => {
      if(window.location.pathname != '/register') {
        document.getElementById('iiris-modal-box').setAttribute('style', 'display: none;')
      }else {
        document.getElementById('iiris-modal-box').setAttribute('style','display: ""')
      }
    };
    // Listen for changes to the browser history
    window.addEventListener('popstate', handleLocationChange);
    const originalPushState = window.history.pushState;
    window.history.pushState = function(...args) {
      originalPushState.apply(this, args);
      handleLocationChange();
    };

    const originalReplaceState = window.history.replaceState;
    window.history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      handleLocationChange();
    };

    // Cleanup function
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);
  // code added to handle removing opr  from dom 


  const getCountryData = useCallback(() => {
    SignerService({
      method:"GET",
      url:identityConfig.apiBaseURL +
        `/v2/taxonomy/public/countries?locale=${identityConfig.language}`,
    }).then((response) => {
      setCountryData(response.data);
    });
  }, [identityConfig]);

  useEffect(() => {
    getCountryData();
    localStorage.setItem("iiris_ust", new Date());
  }, [getCountryData]);

  useEffect(() => {    
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy.forEach((page, index) => {
        page[`page${index + 1}`].forEach((question) => {
          let profile_id = question.profile_id
            ? question.profile_id
            : question.id;
          if (question.hasOwnProperty("isCompany")) {
            if (question.company_fields.type === "array") {
              const value = get(
                companyData[userDomain],
                question.company_fields.key_name
              );
              question[profile_id] = value ? value[0] : "";
            } else if (question.company_fields.type === "string") {
              const value = get(
                companyData[userDomain],
                question.company_fields.key_name
              );
              question[profile_id] = value ? value.toString() : "";
            }
          }
        });
      });
      return prevStateCopy;
    });
  }, [companyData, userDomain]);

  const getQuestionData = useCallback(async () => {
    pages.map((page, index) => {
      page.questions.map(async (question, i) => {
        let profile_id = question.profile_id
          ? question.profile_id
          : question.id;
        if (question.fetch === "dynamic") {
          try {
            const response = await SignerService({
              method:"GET",
              url:identityConfig.apiBaseURL +
                "/" +
                question.url.replace("{division}/{brand}", "") +
                identityConfig.division +
                "/" +
                identityConfig.brand +
                "?locale=" +
                language,
          });
            const questionId = profile_id;
            setQuestionData((prevState) => {
              const newData = {
                ...prevState,
                [`page${index + 1}`]: {
                  ...prevState[`page${index + 1}`],
                  [questionId]: response.data ? response.data : response,
                },
              };
              return newData;
            });
            setFilteredQuestionData((prevState) => {
              const newData = {
                ...prevState,
                [`page${index + 1}`]: {
                  ...prevState[`page${index + 1}`],
                  [questionId]: response.data ? response.data : response,
                },
              };
              return newData;
            });
          } catch (e) {
            console.log(e);
          }
        } else if (question.fetch === "static") {
          const questionId = profile_id;
          setQuestionData((prevState) => {
            const newData = {
              ...prevState,
              [`page${index + 1}`]: {
                ...prevState[`page${index + 1}`],
                [questionId]: getLocalizedData(question.data),
              },
            };
            return newData;
          });
          setFilteredQuestionData((prevState) => {
            const newData = {
              ...prevState,
              [`page${index + 1}`]: {
                ...prevState[`page${index + 1}`],
                [questionId]: getLocalizedData(question.data),
              },
            };
            return newData;
          });
        }
      });
      return null;
    });
  }, [
    identityConfig.brand,
    identityConfig.division,
    identityConfig.apiBaseURL,
    pages,
  ]);

  useEffect(() => {
    getQuestionData();
    setPosition('static');
    window.scrollTo(0, 0);
  }, [getQuestionData]);

  useEffect(() => {
    try {
      const evtObj = {};
      evtObj.cat = "IRISIdentityEvent";
      evtObj.lbl = "Page Visited";
      evtObj.act = "progressiveProfile";
      evtObj.prop = "progressiveProfile";
      evtObj.val = 1.0;
      if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
        window.IIRISTracker.trackStructEvt(evtObj);
      }
    } catch (error) {
      console.log(error);
    }
    if (userObj?.email) {
      getAudienceProfile(userObj.email);
    }
    setFullName(userObj?.given_name + " " + userObj?.family_name);
    if (userObj?.picture) {
      setProfilePic(userObj?.picture);
    }
    //Set User to Track
    if (userObj && userObj?.id) {
      document.cookie =
        "IRIS_ID=" +
        userObj.id +
        "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
        window.location.hostname;
      sha256(userObj.email.toLowerCase()).then((hash) => {
        document.cookie =
          "IRIS_UHASH=" +
          hash +
          "; path=/; max-age=7776000; samesite=strict; secure;domain=" +
          window.location.hostname;
      });
      if (window.IIRISTracker && window.snowplow) {
        window.snowplow("setUserIdFromCookie", "IRIS_ID");
      }
    }
  }, [identityConfig.apiBaseURL, userObj]);

  const redirectToSignIn = () => {
    localStorage.setItem("widget_screen", "signin");
    props.setFormType("signin");
    props.setPosition("fixed");
    try {
      const evtObj = {};
      evtObj.cat = "IRISIdentityEvent";
      evtObj.lbl = "Page Visited";
      evtObj.act = "login";
      evtObj.prop = "emailLogin";
      evtObj.val = 1.0;
      if (window.IIRISTracker && window.IIRISTracker.trackStructEvt) {
        window.IIRISTracker.trackStructEvt(evtObj);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const redirectToForgetPassword = () => {
    props.setFormType("forgetpassword");
  };

  const showSignUpWithEmailFields = () => {
    setError("");
    setShowToggleButton(false);
    setShowEmailSignInInfo(true);
  };

  function hasError(key) {
    return errors.indexOf(key) !== -1;
  }

  const getLocalizedData = (data) => {
    let localizedData = [];
    const locale = language;
    if (data) {
      for (let i = 0; i < data.length; i++) {
        if (!data[i].locale && locale === "en") {
          localizedData.push(data[i]);
        } else if (data[i].locale && data[i].locale === locale) {
          localizedData.push(data[i]);
        }
      }
    }
    return localizedData;
  };

  const validateForm = () => {
    const enteredGivenName = givenNameInputRef.current.value;
    const enteredFamilyName = familyNameInputRef.current.value;
    const enteredEmail = emailInputRef.current.value;
    const enteredPassword = passwordInputRef.current.value;
    const enteredConfirmPassword = confirmPasswordInputRef.current.value;
    let isValid = true;
    const errs = [];
    if (enteredGivenName === "") {
      isValid = false;
      errs.push("givenNameInputRef");
    }

    if (enteredFamilyName === "") {
      isValid = false;
      errs.push("familyNameInputRef");
    }

    if (enteredEmail === "") {
      isValid = false;
      errs.push("emailInputRef");
      setEmailError("emailValidation");
    }

    //email validation
    var validEmail = validator.isEmail(enteredEmail);

    if (emailError !== "") {
      isValid = false;
    }

    if (!validEmail) {
      isValid = false;
      errs.push("emailInputRef");
    }

    if (enteredPassword.length < 8) {
      isValid = false;
      errs.push("passwordInputRef");
    }
    if (enteredPassword.toLowerCase() === enteredPassword) {
      isValid = false;
      errs.push("passwordInputRef");
    }

    if (enteredPassword.toUpperCase() === enteredPassword) {
      isValid = false;
      errs.push("passwordInputRef");
    }

    if (!/\d/.test(enteredPassword)) {
      isValid = false;
      errs.push("passwordInputRef");
    }

    if (!hasSpecialChars(enteredPassword)) {
      isValid = false;
      errs.push("passwordInputRef");
    }

    if (enteredConfirmPassword !== enteredPassword) {
      isValid = false;
      errs.push("confirmPasswordInputRef");
    }

    if (selectedCountry === "") {
      isValid = false;
      errs.push("country");
    }

    if (selectedState === "" && stateData.length > 0) {
      isValid = false;
      errs.push("state");
    }

    if (identityConfig.captcha && !isHuman) {
      isValid = false;
      errs.push("captcha");
    }

    questionSelection.map((page, index) =>
      page[`page${index + 1}`].map((question) => {
        let profile_id = question.profile_id
          ? question.profile_id
          : question.id;
        let question_type = question.type ? question.type : "";
        const selectedQuestionId = profile_id;
        const selectedQuestionVal = question[profile_id];
        if (
          selectedQuestionId === "product_category" ||
          question_type === "multiselect-list"
        ) {
          if (checkedListItems.length === 0) {
            if (question.required) {
              errs.push(selectedQuestionId);
              isValid = false;
            }
          }
        } else {
          if (selectedQuestionId === "phone_number") {
            let isPhoneNumber = false;
            if (selectedQuestionVal.startsWith("+")) {
              const possiblePhoneNumber = selectedQuestionVal
                .replaceAll(" ", "")
                .slice(1);
              const isNum = /^\d+$/.test(possiblePhoneNumber);
              isPhoneNumber =
                isNum &&
                possiblePhoneNumber.length < 16 &&
                possiblePhoneNumber.length > 8;
            }
            if (!isPhoneNumber) {
              if (question.required) {
                errs.push(selectedQuestionId);
                isValid = false;
              }
            }
          }
          if (!selectedQuestionVal) {
            if (question.required) {
              errs.push(selectedQuestionId);
              isValid = false;
            }
          }
        }
      })
    );

    switch (countryType) {
      case "A":
        if (!isTypeAConsentSelected) {
          isValid = false;
          errs.push("Aterms");
        }
        break;
      default:
        break;
    }

    if (!isValid) {
      setError("");
    }
    setErrors(errs);
    return isValid;
  };

  const trackFields = (prevStateCopy) => {
    try {
      fieldInfo["abandoned_on"] = "page1_dropout";
      fieldInfo["email"] = identityConfig.email_case_insensitive
        ? emailInputRef.current.value.toLowerCase()
        : emailInputRef.current.value;
      fieldInfo["first_name"] = givenNameInputRef.current.value;
      fieldInfo["last_name"] = familyNameInputRef.current.value;
      localStorage.setItem("trackedFields", JSON.stringify(fieldInfo));
      let trackerInfo = {};
      if (prevStateCopy) {
        trackerInfo = prevStateCopy;
      } else {
        trackerInfo = questionSelection;
      }
      trackerInfo.map((page, index) =>
        page[`page${index + 1}`].map((question) => {
          let profile_id = question.profile_id
            ? question.profile_id
            : question.id;
          const selectedQuestionId = profile_id;
          const selectedQuestionVal = question[profile_id];
          let filteredOrderedQuestion = orderedQuestions.filter((obj) => {
            return obj.id == selectedQuestionId;
          });
          if (
            "render" in filteredOrderedQuestion[0]
              ? filteredOrderedQuestion[0]["render"]
              : true
          ) {
            if (selectedQuestionId === "job_function") {
              fieldInfo["job_functions"] = [
                {
                  id: selectedQuestionVal,
                  division: identityConfig.division,
                  brand: identityConfig.brand,
                },
              ];
            } else if (selectedQuestionId === "business_type") {
              fieldInfo["business_types"] = [
                {
                  id: selectedQuestionVal,
                  division: identityConfig.division,
                  brand: identityConfig.brand,
                },
              ];
            } else if (selectedQuestionId === "product_category") {
              fieldInfo["product_categories"] = [
                {
                  categories: checkedListItems,
                  division: identityConfig.division,
                  brand: identityConfig.brand,
                },
              ];
            } else if (selectedQuestionId === "property_category") {
              fieldInfo["property_categories"] = [
                {
                  categories: checkedListItems,
                  division: identityConfig.division,
                  brand: identityConfig.brand,
                },
              ];
            } else if (selectedQuestionId === "phone_number") {
              fieldInfo["phones"] = [selectedQuestionVal.replaceAll(" ", "")];
            } else {
              if (isAudienceQuestion(selectedQuestionId)) {
                fieldInfo[selectedQuestionId] = selectedQuestionVal;
              }
            }
          }
        })
      );
      localStorage.setItem("trackedFields", JSON.stringify(fieldInfo));
    } catch (error) {
      console.log(error);
    }
  };

  const handleChipClick = (questionId, selectedChip, index) => {
    filterQuestionsData(questionId, [selectedChip], index);
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        selectedChip.id;
      trackFields(prevStateCopy);
      if (selectedChip.id) {
        const validErrors = errors.filter(error => error !== questionId);
        setErrors(validErrors);
      } else {
        setErrors([...errors, questionId]);
      }
      return prevStateCopy;
    });
  };

  const handleTextInputChange = (questionId, val, index) => {
    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        val;
      trackFields(prevStateCopy);
      if (val) {
        const validErrors = errors.filter(error => error !== questionId);
        setErrors(validErrors);
      } else {
        setErrors([...errors, questionId]);
      }
      return prevStateCopy;
    });
  };

  const onDropdownChange = (questionId, e, index) => {
    filterQuestionsData(questionId, e, index);

    if (e.length !== 0) {
      setQuestionSelection((prevState) => {
        const prevStateCopy = JSON.parse(JSON.stringify(prevState));
        prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
          e[0].id;
        trackFields(prevStateCopy);
        const validErrors = errors.filter(error => error !== questionId);
        setErrors(validErrors);
        return prevStateCopy;
      });
    } else {
      setQuestionSelection((prevState) => {
        const prevStateCopy = JSON.parse(JSON.stringify(prevState));
        prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
          "";
        trackFields(prevStateCopy);
        setErrors([...errors, questionId]);
        return prevStateCopy;
      });
    }
  };

  const handleCheckboxChange = (questionId, event, index) => {
    filterQuestionsData(questionId, event, index);

    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        event.target.checked;
      trackFields(prevStateCopy);
      return prevStateCopy;
    });
  };

  const handleRadioButton = (questionId, event, index) => {
    filterQuestionsData(questionId, event, index);

    setQuestionSelection((prevState) => {
      const prevStateCopy = JSON.parse(JSON.stringify(prevState));
      prevStateCopy[pageNumber - 1][`page${pageNumber}`][index][questionId] =
        event.target.value;
      trackFields(prevStateCopy);
      return prevStateCopy;
    });
  };

  function filterArrayDataByValue(arr, filterConstraint, question_id) {
    let data = arr.filter((obj) => {
      return (
        obj.parentId === question_id &&
        obj.parentValue.split(",").includes(filterConstraint.id)
      );
    });

    return data;
  }

  // Dependent Prompts Logic: Function to filter questions data
  const filterQuestionsData = (questionID, selectedId, index) => {
    let questionConfigs = pages[pageNumber - 1].questions.find(
      (o) => o.id === questionID
    );
    let selectedPage = "page" + pageNumber;

    if ("children" in questionConfigs && questionConfigs.children.length != 0) {
      let questionsToFilter = questionConfigs.children;
      for (let i = 0; i < questionsToFilter.length; i++) {
        let filteredData = filterArrayDataByValue(
          questionData[selectedPage][questionsToFilter[i]],
          selectedId[0],
          questionID
        );
        Object.keys(filteredQuestionData[selectedPage]).forEach((item) => {
          if (item == questionsToFilter[i]) {
            filteredQuestionData[selectedPage][item] = filteredData;
          }
        });

        //  Render the dependent questions by changing render property.
        let filteredOrderedQuestion = orderedQuestions.filter((obj) => {
          return obj.id == questionsToFilter[i];
        });
        if (
          "render" in filteredOrderedQuestion[0] &&
          filteredOrderedQuestion[0]["data"] &&
          checkIfParentValueContainsSelectedID(
            filteredOrderedQuestion[0]["data"],
            selectedId[0].id
          )
        ) {
          filteredOrderedQuestion[0]["render"] = true;
        } else if ("render" in filteredOrderedQuestion[0]) {
          filteredOrderedQuestion[0]["render"] = false;
        }

        // Reset the children question selections
        let filteredQuestionSelection = questionSelection[pageNumber - 1][
          selectedPage
        ].filter((obj) => {
          return obj.id == questionsToFilter[i];
        });
        if (questionsToFilter[i] in filteredQuestionSelection[0]) {
          filteredQuestionSelection[0][questionsToFilter[i]] = "";
        }

        // Reset the multi-select children question selection if any
        if (
          questionsToFilter[i] in questionData[selectedPage] &&
          orderedQuestions.filter((obj) => {
            return obj.id == questionsToFilter[i];
          })[0]["type"] == "multiselect-list"
        ) {
          setCheckedListItems([]);
        }
      }
    }
  };

  const checkIfParentValueContainsSelectedID = (data, selectedId) => {
    let isIdSelected = false;

    data.forEach((obj) => {
      const parentValueArr = obj.parentValue.split(",");
      parentValueArr.forEach((val) => {
        if (val.trim() === selectedId) {
          isIdSelected = true;
          return;
        }
      });
      if (isIdSelected) {
        return;
      }
    });

    return isIdSelected;
  };

  // Add/Remove checked item from list
  const handleListCheck = (event) => {
    let updatedList = [...checkedListItems];

    if (event.target.checked) {
      updatedList = [...checkedListItems, { id: event.target.value }];
    } else {
      updatedList = checkedListItems.filter(
        (listItem) => listItem.id !== event.target.value
      );
    }
    setCheckedListItems(updatedList);
  };

  const getAudienceProfile = (email) => {
    try {
      let payload = {
        email: email,
        profile_type: "business_email",
      };
      IRISService.makePostRequest(
        identityConfig.apiBaseURL + "/v3/audience/profileinfo",
        payload,
        authToken.current
      )
        .then((audResponse) => {
          if (audResponse.status === "success") {
            const data = audResponse.data[0];
            userObj.id = data.id;
            userObj.country = data.country;
            userObj.state = data.state;
            userObj.is_social_login = data.is_social_login;
            userObj.social_accounts = data.social_accounts;
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setPosition('static');
        });
    } catch (errorResp) {
      setIsLoading(false);
      setPosition('static');
    }
  };

  const handlePageClick = (e, type) => {
    e.preventDefault();
    if (type === "prev") {
      setPageNumber((prevState) => prevState - 1);
    }
    if (type === "next") {
      setPageNumber((prevState) => prevState + 1);
    }
  };

  const getQuestionTitle = (question) => {
    if (question.hasOwnProperty("config")) {
      const filteredQuestionArray = question.config.filter(
        (configObj) =>
          configObj.brand === brand &&
          configObj.division === division &&
          configObj.locale === language
      );
      if (filteredQuestionArray.length > 0) {
        return filteredQuestionArray[0].title;
      } else {
        return question.title || "";
      }
    } else {
      return question.title || "";
    }
  };

  const isAudienceQuestion = (questionId) => {
    let flag = false;
    const questions = pages[0].questions;
    questions.map((que) => {
      let profile_id = que.profile_id ? que.profile_id : que.id;
      if (profile_id === questionId) {
        if (que.isAudience) {
          flag = true;
          return flag;
        }
      }
    });
    return flag;
  };

  const clearIRISCookies = () => {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if (name.indexOf("IRIS_") >= 0) {
        document.cookie =
          name +
          "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" +
          window.location.hostname;
      }
    }
  };

  const userExistCheck = () => {
    let emailToValidate =  emailInputRef.current.value.toLowerCase();
        var validEmail = validator.isEmail(emailToValidate);
        if (validEmail) {
          const payload = {
            "username": emailToValidate,
            "client_id": identityConfig.clientId
          };
      const url =
        identityConfig.apiBaseURL +
        "/v3/authorization/public/passport/checkuser";
      return SignerService({
        method:"POST",
        url,
        body:payload
      }).then((response) => {
        if (response && response.status === "success") {
          const code = response.data.code;
          switch (code) {
            case "UserNotFound":
              setEmailError("");
              break;
            case "UserFound":
              setEmailError("userExistCheck");
              break;
            case "PasswordResetRequired":
              setEmailError("passwordResetCheck");
              break;
            case "UserNotConfirmed":
              setEmailError("invalidUser");
              break;
            default:
              setEmailError("");
          }
        }
      });
    } else {
      setEmailError("emailValidation");
    }
  };

  // Select Event Functionality
  const OnCountrySelectChange = (...e) => {
    if (e.length !== 0) {
      setSelectedCountry(e[1].name);
      setSelectedCountryId(e[1].id);
      setStateData(e[1].states);
      fieldInfo["country"] = e[1].id;
      fieldInfo["country_name"] = e[1].name;
      setSelectedState("");
      setSelectedStateId("");
      var countryTypeVal = e[1].group;
      if (countryType === 'A') {
        setTypeAConsentSelected(false);
      }
      setCountryType(countryTypeVal);
      const validErrors = errors.filter(error => error !== "country");
      setErrors(validErrors);
    } else {
      setSelectedCountry("");
      setCountryType("");
    }
    trackFields();
  };

  const OnStateSelectChange = (...e) => {
    if (e.length !== 0) {
      setSelectedStateId(e[1].id);
      setSelectedState(e[1].name);
      fieldInfo["state"] = e[1].id;
      fieldInfo["state_name"] = e[1].name;
      const validErrors = errors.filter(error => error !== "state");
      setErrors(validErrors);
    } else {
      setSelectedState("");
      setSelectedStateId("");
    }
    trackFields();
  };

  const validateField = (field) => {
    if (field.value === "") {
      field.classList.add(classes["error-border"]);
      setErrors([...errors, field.id]);
    } else {
      field.classList.remove(classes["error-border"]);
      const index = errors.findIndex((error) => error === field.id);
      if (index !== -1) {
        let newErrors = [...errors];
        newErrors.splice(index, 1);
        setErrors(newErrors);
      }
    }
    setError("");
  };

  const handleConsent = async (accessToken, userObj) => {
    try {
      const consentPayload = {
        iiris_id: userObj.id,
        product_id: identityConfig.id,
        product_type: identityConfig.siteType,
        product_sub_type: identityConfig.siteSubType,
        version: "2.x",
        date: new Date(),
        country: userObj.country,
        country_group: userObj.countryType ? userObj.countryType : "",
        consent: [
          {
            type: "PP",
            sub_type: "",
            text: privacy_policy_text,
            link: "https://www.informa.com/privacy-policy/",
            flag: true,
          },
        ],
      };
      if (fp_consent !== null) {
        consentPayload.consent.push({
          type: "1P",
          sub_type: "non-purchase",
          text: FP_text,
          link: "",
          flag: fp_consent,
        });
      } else if (
        fp_consent == null &&
        (countryType === "B" || countryType === "C" || countryType === "D")
      ) {
        consentPayload.consent.push({
          type: "1P",
          sub_type: "non-purchase",
          text: t("tick_here_text"),
          link: "",
          flag: true,
        });
      }
      IRISService.makePostRequest(
        identityConfig.apiBaseURL + "/v3/audience/consent",
        consentPayload,
        accessToken
      );
    } catch (e) {
      console.log(e);
    }
  };
  //Sign Up with Email
  const signUpWithEmail = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return;
    }

    if (identityConfig.captcha) {
      if (identityConfig.captcha_type === "recaptcha") {
        recaptchaRef.current.reset();
      } else if (identityConfig.captcha_type === "hcaptcha") {
        hcaptchaRef.current.resetCaptcha();
      }
      setIsHuman(false);
    }
    setError("");
    setIsLoading(true);
    setPosition('fixed');

    //Read the values from the form
    const given_name = givenNameInputRef.current.value;
    const family_name = familyNameInputRef.current.value;
    const email = identityConfig.email_case_insensitive
      ? emailInputRef.current.value.toLowerCase()
      : emailInputRef.current.value;
    const password = passwordInputRef.current.value;
    const country = selectedCountry;
    const state = selectedState;
    const username = email;

    // Create an AES cipher object with Cipher Block Chaining (CBC) mode
    const cipher = await window.crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(process.env.REACT_SECRET_KEY),
      { name: "AES-GCM" },
      false,
      ["encrypt"]
    );

    // The initialization vector should be a random value and different for each request
    const iv = new Uint8Array(16);
    window.crypto.getRandomValues(iv);

    // Encrypt the password with the IV and cipher
    const encodedPassword = new TextEncoder().encode(password);
    const encryptedPassword = new Uint8Array(
      await window.crypto.subtle.encrypt(
        { name: "AES-GCM", iv: iv },
        cipher,
        encodedPassword
      )
    );

    // Encode the encrypted password and IV using Base64
    const encodedEncryptedPassword = btoa(
      String.fromCharCode(...new Uint8Array(encryptedPassword.buffer))
    );
    const encodedIV = btoa(String.fromCharCode(...new Uint8Array(iv.buffer)));

    try {
      const signUpPayload = {
        username: username,
        password: password,
        hcaptcha_token: hcaptchaRes,
        user_attributes: [
          {
            Name: "email",
            Value: username,
          },
          {
            Name: "given_name",
            Value: given_name,
          },
          {
            Name: "family_name",
            Value: family_name,
          },
          {
            Name: "custom:terms",
            Value: "true",
          },
          {
            Name: "custom:country",
            Value: country,
          },
          {
            Name: "custom:state",
            Value: state,
          },
        ],
        client_id: identityConfig.clientId
      };
      const url =
        identityConfig.apiBaseURL + "/v3/authorization/public/passport/signup";
      SignerService({ method:"POST", url, body:signUpPayload})
        .then(() => {
          // send the encoded encrypted password and IV in the POST body to the backend
          const loginPayload = {
            auth_flow: "CUSTOM_SRP_AUTH",
            username: username,
            srp_key: encodedEncryptedPassword,
            salt: encodedIV,
            client_id: identityConfig.clientId
          };

          const url =
            identityConfig.apiBaseURL +
            "/v3/authorization/public/passport/initiateauth";
          SignerService({
            method:"POST",
            url,
            body:loginPayload
        })
            .then((response) => {
              document.cookie = `IRIS_AUTH=${response.data.AuthenticationResult.AccessToken}; path=/; max-age=${response.data.AuthenticationResult.ExpiresIn}; samesite=strict; secure;domain=${window.location.hostname}`;
              document.cookie = `IRIS_HASH=${response.data.AuthenticationResult.RefreshToken}; path=/; max-age=${response.data.RefreshTokenExpiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
              document.cookie = `IRIS_APPID=${identityConfig.id}; path=/; max-age=${response.data.RefreshTokenExpiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
              localStorage.setItem("is_social_login", false);
              authToken.current =
                response.data.AuthenticationResult.AccessToken;
              const audPayload = {
                business_email: email,
                first_name: given_name,
                last_name: family_name,
                company: "",
                product_ids: [identityConfig.id],
                country: selectedCountryId,
                country_name: selectedCountry,
                state: selectedStateId,
                state_name: selectedState,
                job_title: "",
                is_social_login: false,
                business_type: "",
                job_function: "",
                social_accounts: [],
                audience_source: identityConfig.siteName
                  ? identityConfig.siteName
                  : "",
              };
              IRISService.makePostRequest(
                identityConfig.apiBaseURL + "/v3/audience/profile",
                audPayload,
                response.data.AuthenticationResult.AccessToken
              )
                .then(async (audResponse) => {
                  if (audResponse.status === "success") {
                    const responseData = audResponse.data[0];
                    const user = {
                      id: responseData.id,
                      email: responseData.business_email,
                      given_name: responseData.first_name,
                      family_name: responseData.last_name,
                      flow: "emailSignup",
                      product_ids: responseData.product_ids,
                      country: responseData.country,
                      country_id: selectedCountryId,
                      country_name: responseData.country_name,
                      countryType: countryType,
                      state: responseData.state,
                      state_name: responseData.state_name,
                      company: responseData.company,
                      job_title: responseData.job_title,
                      is_social_login: responseData.is_social_login,
                      business_type: responseData.business_type,
                      job_function: responseData.job_function,
                      social_accounts: responseData.social_accounts,
                    };
                    setUserObj(user);
                    //Set User to Track
                    document.cookie = `IRIS_ID=${user.id}; path=/; max-age=${response.data.RefreshTokenExpiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
                    sha256(user.email.toLowerCase()).then((hash) => {
                      document.cookie = `IRIS_UHASH=${hash}; path=/; max-age=${response.data.RefreshTokenExpiry || 7776000}; samesite=strict; secure;domain=${window.location.hostname}`;
                    });
                    if (window.IIRISTracker && window.snowplow) {
                      window.snowplow("setUserIdFromCookie", "IRIS_ID");
                    }
                    try {
                    //Tracker Sign Up Event for Sign Up
                      const transactionID =
                        window.localStorage.getItem("regTransactionId");
                      const evt = {
                        entityId: "NA",
                        transactionId: transactionID,
                        formId: "registration",
                        status: "page1submit-email",
                        type: "register",
                        ts: new Date().toISOString(),
                      };
                      const asset = {
                        id: "NA",
                        name: window.location.host,
                        type: "form",
                        size: 0,
                        url: window.location.href,
                        created: new Date().toISOString(),
                        lastUpdated: new Date().toISOString(),
                        tags: "SignUp",
                        metadata: JSON.stringify(user),
                      };
                      trackBusinessEvt(evt, asset);
                    } catch (trackerError) {
                      console.log(trackerError)
                    }

                    let regPayload = {
                      iris_id: user.id,
                      product_id: identityConfig.id,
                      product_type: identityConfig.siteType,
                      product_sub_type: identityConfig.siteSubType,
                      product_name: identityConfig.siteName,
                      user_enroll_date: new Date(),
                      questions: {
                        user_enroll_type:
                          language === "en"
                            ? identityConfig.welcome_email_template
                            : identityConfig.welcome_email_template +
                              "_" +
                              language,
                      },
                      mode: identityConfig.environment_mode,
                      locale: identityConfig.locale
                    };

                    const rolesPayload = {
                      product_id: identityConfig.id,
                      iris_id: user.id,
                      business_email: user.email,
                      questions: {},
                      product_type: identityConfig.siteType,
                      product_sub_type: identityConfig.siteSubType,
                      product_name: identityConfig.siteName,
                    };
                    let payload = {
                      business_email: user.email,
                      first_name: user.given_name,
                      last_name: user.family_name,
                      country: user.country_id ? user.country_id : user.country,
                      country_name: user.country_name,
                      state: user.state,
                      state_name: user.state_name,
                      is_social_login: user.is_social_login,
                      social_accounts: user.social_accounts,
                    };
                    questionSelection.map((page, index) =>
                      page[`page${index + 1}`].map((question) => {
                        let profile_id = question.profile_id
                          ? question.profile_id
                          : question.id;
                        const selectedQuestionId = profile_id;
                        const selectedQuestionVal = question[profile_id];
                        if (question.hasOwnProperty("isRole")) {
                          rolesPayload.questions[selectedQuestionId] =
                            selectedQuestionVal;
                        }
                        let filteredOrderedQuestion = orderedQuestions.filter(
                          (obj) => {
                            return obj.id == selectedQuestionId;
                          }
                        );
                        if (
                          "render" in filteredOrderedQuestion[0]
                            ? filteredOrderedQuestion[0]["render"]
                            : true
                        ) {
                          if (selectedQuestionId === "job_function") {
                            payload["job_functions"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["job_functions"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (selectedQuestionId === "business_type") {
                            payload["business_types"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["business_types"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (
                            selectedQuestionId === "product_category"
                          ) {
                            payload["product_categories"] = [
                              {
                                categories: checkedListItems,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["product_categories"] = [
                              {
                                categories: checkedListItems,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (
                            selectedQuestionId === "property_category"
                          ) {
                            payload["property_categories"] = [
                              {
                                categories: checkedListItems,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["property_categories"] = [
                              {
                                categories: checkedListItems,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (selectedQuestionId === "phone_number") {
                            payload["phones"] = [
                              selectedQuestionVal.replaceAll(" ", ""),
                            ];
                          } else if (selectedQuestionId === "industry") {
                            payload["industries"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["industries"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (selectedQuestionId === "market_sectors") {
                            payload["market_sectors"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["market_sectors"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else if (selectedQuestionId === "interests") {
                            payload["interests"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                            regPayload.questions["interests"] = [
                              {
                                id: selectedQuestionVal,
                                division: identityConfig.division,
                                brand: identityConfig.brand,
                              },
                            ];
                          } else {
                            if (isAudienceQuestion(selectedQuestionId)) {
                              payload[selectedQuestionId] = selectedQuestionVal;
                            }
                            regPayload.questions[selectedQuestionId] =
                              selectedQuestionVal;
                          }
                        }
                      })
                    );
                    await IRISService.makePostRequest(
                      identityConfig.apiBaseURL +
                        "/v3/audience/registration",
                      regPayload,
                      authToken.current
                    );
                    if (configureRoles) {
                      await IRISService.makePostRequest(
                        identityConfig.apiBaseURL + "/v1/roles",
                        rolesPayload,
                        authToken.current
                      );
                    }

                    if (user.id && user.id !== "") {
                      payload.id = user.id;
                    }
                    try {
                      const response = await IRISService.makePostRequest(
                        identityConfig.apiBaseURL +
                          "/v3/audience/profile",
                        payload,
                        authToken.current
                      );
                      if (response.status === "success") {
                        try {
                          //Tracker Profile Submit Event for Sign Up
                          const transactionID =
                            window.localStorage.getItem("regTransactionId");
                          const evt = {
                            entityId: "NA",
                            transactionId: transactionID,
                            formId: "progressive",
                            status: "page2submit",
                            type: "register",
                            ts: new Date().toISOString(),
                          };
                          const asset = {
                            id: "NA",
                            name: window.location.host,
                            type: "form",
                            size: 0,
                            url: window.location.href,
                            created: new Date().toISOString(),
                            lastUpdated: new Date().toISOString(),
                            tags: "success",
                            metadata: JSON.stringify(payload),
                          };
                          trackBusinessEvt(evt, asset);
                        } catch (error) {
                          console.log(error);
                        }
                        if (localStorage.getItem("iiris_ust")) {
                          const timeData = {};
                          timeData.cat = "IRISIdentityEvent";
                          timeData.lbl = "Capture Time";
                          timeData.act = "registrationTime";
                          timeData.prop = "registrationTime";
                          const startTime = Date.parse(
                            localStorage.getItem("iiris_ust")
                          );
                          const endTime = new Date();
                          timeData.val = (endTime - startTime).toFixed(2);
                          if (
                            window.IIRISTracker &&
                            window.IIRISTracker.trackStructEvt
                          ) {
                            window.IIRISTracker.trackStructEvt(timeData);
                          }
                        }
                        if (identityConfig.persist_session === false) {
                          clearIRISCookies();
                        }
                        if (window.irisRegisterCallback) {
                          IRISService.makeGetRequest(
                            `${identityConfig.apiBaseURL}/v3/audience/profile/${response.data[0].id}/${identityConfig.id}`,
                            authToken.current
                          )
                            .then((res) => {
                              if (res.status === "success") {
                                let userCallbackdata = res.data[0];
                                userCallbackdata.profile_picture =
                                  localStorage.getItem("profile_picture")
                                    ? localStorage.getItem("profile_picture")
                                    : "";
                                userCallbackdata.is_social_login = JSON.parse(
                                  localStorage.getItem("is_social_login")
                                );
                                const regCallBackObj = {
                                  success: true,
                                  user: userCallbackdata,
                                  token: authToken.current,
                                };
                                window.irisRegisterCallback(regCallBackObj);
                                localStorage.removeItem("widget_screen");
                              } else if (res.status === "error") {
                                const regCallBackObj = {
                                  success: false,
                                  user: null,
                                  token: null,
                                };
                                window.irisRegisterCallback(regCallBackObj);
                                localStorage.removeItem("widget_screen");
                              }
                            })
                            .catch((err) => {
                              const regCallBackObj = {
                                success: false,
                                user: null,
                                token: null,
                              };
                              window.irisRegisterCallback(regCallBackObj);
                            });
                        }
                        localStorage.setItem("CheckLocalUser", "NO");
                        if (identityConfig.showShareIcons !== "") {
                          setState("userDetails");
                        } else {
                          identityConfig.toggleModal();
                          
                        }
                      } else if (response.status === "error") {
                        setIsLoading(false);
                        setPosition('static');
                        setError(response.message);
                      }
                    } catch (e) {
                      setIsLoading(false);
                      setPosition('static');
                      setError(e.message);
                    }

                    handleConsent(
                      response.data.AuthenticationResult.AccessToken,
                      user
                    );
                    setIsLoading(false);
                    setPosition('static');
                    localStorage.setItem("CheckLocalUser", "NO");
                  } else if (audResponse.status === "error") {
                    setIsLoading(false);
                    setPosition('static');
                    setError(audResponse.message);
                    setEmailError("");
                  }
                })
                .catch((e) => {
                  console.log(e);
                  setIsLoading(false);
                  setPosition('static');
                  setError("Signup failed.");
                  setEmailError("");
                });
            })
            .catch((e) => {
              console.log(e);
              setIsLoading(false);
              setPosition('static');
              setError("Signup failed.");
            });
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
          setPosition('static');
          setError("Signup failed.");
        });
    } catch (e) {
      setIsLoading(false);
      setPosition('static');
      setError(e.message);
      setContainsUL(false);
      setContainsLL(false);
      setContainsN(false);
      setContainsSC(false);
      setContains8C(false);
      setPasswordMatch(false);
      setEmailError("");
    }
    
    if(!isLoading){
      let onePageEle = document.getElementById('iiris-identity');
			if (onePageEle && onePageEle.nextElementSibling) {
   				 onePageEle.nextElementSibling.style.display = 'block';
				}
    }
  };

  const hasSpecialChars = (str) => {
    let iChars = "~`!#$%@^&*+=-[]\\'_;,/{}()|\":<>?";
    for (var i = 0; i < str.length; i++) {
      if (iChars.indexOf(str.charAt(i)) !== -1) {
        return true;
      }
    }
    return false;
  };

  const validatePassword = () => {
    // has uppercase letter
    const hasUpperCase =
      passwordInputRef.current.value.toLowerCase() !==
      passwordInputRef.current.value;
    setContainsUL(hasUpperCase);

    // has lowercase letter
    const hasLowerCase =
      passwordInputRef.current.value.toUpperCase() !==
      passwordInputRef.current.value;
    setContainsLL(hasLowerCase);

    // has number
    const hasNumber = /\d/.test(passwordInputRef.current.value);
    setContainsN(hasNumber);

    // has special character
    const hasSpChrs = hasSpecialChars(passwordInputRef.current.value);
    setContainsSC(hasSpChrs);

    // has 8 characters
    const hasLength8 = passwordInputRef.current.value.length >= 8;
    setContains8C(hasLength8);

    if (hasLength8 && hasLowerCase && hasUpperCase && hasSpChrs && hasNumber) {
      const validErrors = errors.filter(error => error !== 'passwordInputRef');
      setErrors(validErrors);
    }

    // passwords match
    const passwordMatches =
      passwordInputRef.current.value.length > 0 &&
      passwordInputRef.current.value === confirmPasswordInputRef.current.value;
    setPasswordMatch(passwordMatches);
    if (passwordMatches) {
      const validErrors = errors.filter(error => error !== 'confirmPasswordInputRef');
      setErrors(validErrors);
    }
  };

  const showHidePassword = (event) => {
    const type =
      passwordInputRef.current.type === "password" ? "text" : "password";
    passwordInputRef.current.type = type;
    event.target.classList.toggle("bi-eye");
  };

  const showHideConfirmPassword = (event) => {
    const type =
      confirmPasswordInputRef.current.type === "password" ? "text" : "password";
    confirmPasswordInputRef.current.type = type;
    event.target.classList.toggle("bi-eye");
  };

  const showHidePasswordRules = () => {
    setshowPasswordRules(!showPasswordRules);
  };

  // ReCAPTCHA Client Side
  const onCaptchaLoad = () => {
    console.log("Captcha loaded.");
  };

  const verifyCaptcha = (res) => {
    if (res) {
      setHcaptchaRes(res);
      setIsHuman(true);
      const validErrors = errors.filter(error => error !== 'captcha');
      setErrors(validErrors);
    }
  };

  const onError = (err) => {
    console.log(`hCaptcha Error: ${err}`);
  };

  // ReCAPTCHA Expired
  const expireCaptcha = () => {
    setIsHuman(false);
  };

  const handleTypeASiteConsent = (event) => {
    setTypeAConsentSelected(true);
    setTypeDConsentSelected(false);
    setFPConsentText(t("FP_consent_text"));
    if (event.target.value === "YES") {
      setFPConsent(true);
    } else if (event.target.value === "NO") {
      setFPConsent(false);
    }
    const validErrors = errors.filter(error => error !== 'Aterms');
    setErrors(validErrors);
  };

  const handleTypeBSiteConsent = (event) => {
    setFPConsentText(t("tick_here_text"));
    if (event.target.checked) {
      setFPConsent(false); // If selected means opt-out here
    } else {
      setFPConsent(true);
    }
  };

  const handleTypeDConsent = (event) => {
    console.log(event);
    setFPConsentText(t("by_continuing"));
    if (event.target.checked) {
      setTypeDConsentSelected(true);
      setTypeAConsentSelected(false);
      setFPConsent(true);
    } else {
      setTypeDConsentSelected(false);
      setTypeAConsentSelected(false);
      setFPConsent(false);
    }
  };

  function filterArrayDataByValue(arr, filterConstraint, question_id) {
    let data = arr.filter((obj) => {
      return (
        obj.parentId === question_id &&
        obj.parentValue.split(",").includes(filterConstraint.id)
      );
    });

    return data;
  }

  return (
    <>
      {isLoading && (
        <div className={classes["iiris-loading-container"]}>
          <LoadingContent />
        </div>
      )}
      {!isLoading && (
        <div className={classes["iiris-registration-form"]}>
          <form method="post" novalidate autoComplete="off">
            <h4 className="iiris-text-center">
              {props.identityConfig.siteName}
            </h4>
            {identityConfig.hide_social.length < 3 ? (
              <div className={classes["iiris-hint-text"]}>{t("sign_up")}</div>
            ) : null}
            <div className={classes["iiris-hint-text"]}>
              {t("already_have")}{" "}
              <span
                onClick={redirectToSignIn}
                className={classes["iiris-login-link"]}
                style={{
                  cursor: "pointer",
                }}
              >
                {t("log_in")}
              </span>
            </div>
            <div
              className={`${classes["iiris-social-media-option-container"]} iiris-social-media-option-container`}
            >
              <SocialProvider
                identityConfig={identityConfig}
                showEmailSignInInfo={showEmailSignInInfo}
                showSignUpWithEmailFields={showSignUpWithEmailFields}
              />
            </div>

            <div style={{ display: showEmailSignInInfo ? "block" : "none" }}>
              {identityConfig.hide_social.length < 3 ? (
                <div
                  className={`${classes["iiris-or-seperator"]} iiris-or-seperator`}
                >
                  <span>Or</span>
                </div>
              ) : null}

              <div
                className={classes["iiris-error-space"]}
                style={{ display: error.length > 0 ? "block" : "none" }}
              >
                {error}
              </div>
              <div style={{ border: "1px solid #E9E9E9", borderRadius: "4px" }}>
                <h4
                  style={{
                    borderBottom: "1px solid ##E9E9E9",
                    padding: "0.65rem 1.3rem",
                  }}
                >
                  Personal Details
                </h4>
                <div className={classes["iiris-form-container-custom"]} style={{paddingTop:'16px'}}>
                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("first_name")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className="iiris-input-group">
                      <input
                        type="text"
                        className={`iiris-form-control${
                          errors.includes("givenNameInputRef")
                            ? ` ${classes["error-border"]}`
                            : ""
                        }`}
                        name="given_name"
                        id="givenNameInputRef"
                        required="required"
                        maxlength="120"
                        ref={givenNameInputRef}
                        onChange={(e) => {
                          validateField(e.target);
                          trackFields();
                        }}
                      />
                    </div>
                    <div
                      className={
                        classes[
                          hasError("givenNameInputRef")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_first")}
                    </div>
                  </div>
                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("last_name")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className="iiris-input-group">
                      <input
                        type="text"
                        className={`iiris-form-control${
                          errors.includes("familyNameInputRef")
                            ? ` ${classes["error-border"]}`
                            : ""
                        }`}
                        name="family_name"
                        id="familyNameInputRef"
                        required="required"
                        maxlength="120"
                        ref={familyNameInputRef}
                        onChange={(e) => {
                          validateField(e.target);
                          trackFields();
                        }}
                      />
                    </div>
                    <div
                      className={
                        classes[
                          hasError("familyNameInputRef")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_last")}
                    </div>
                  </div>
                </div>

                <div className={classes["iiris-form-container-custom"]}>
                  <div
                    style={{
                      width: "100%",
                      marginBottom: "1rem",
                    }}
                  >
                    <label className={classes["iiris-form-label"]}>
                      {t("business_email")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className="iiris-input-group">
                      <input
                        type="email"
                        className="iiris-form-control"
                        name="email"
                        required="required"
                        autoComplete="off"
                        ref={emailInputRef}
                        onChange={(e) => {
                          setEmailError("");
                          trackFields();
                        }}
                        onBlur={userExistCheck}
                        style={{
                          ...((emailError === "emailValidation" ||
                            emailError === "invalidUser" ||
                            emailError === "userExistCheck" ||
                            emailError === "passwordResetCheck") && {
                            borderColor: "red",
                          }),
                        }}
                      />
                    </div>
                    {emailError === "emailValidation" && (
                      <div className={classes["iiris-error-space"]}>
                        {t("valid_email")}
                      </div>
                    )}

                    {emailError === "invalidUser" && (
                      <div className={classes["iiris-error-space"]}>
                        {t("invalid_user_status")}.
                      </div>
                    )}

                    {emailError === "userExistCheck" && (
                      <div className={classes["iiris-error-space"]}>
                        {t("email_already_exist")}{" "}
                        <a
                          href="#"
                          onClick={redirectToSignIn}
                          className={classes["iiris-login-link"]}
                        >
                          {t("here")}
                        </a>{" "}
                        {t("to_login_in")}
                      </div>
                    )}

                    {emailError === "passwordResetCheck" && (
                      <div className={classes["iiris-error-space"]}>
                        {t("email_already_exist_need_password_reset")}{" "}
                        <a
                          href="#"
                          onClick={redirectToForgetPassword}
                          className={classes["iiris-login-link"]}
                        >
                          {t("here")}
                        </a>{" "}
                        {t("to_reset_password")}
                      </div>
                    )}
                  </div>
                </div>

                <div className={classes["iiris-form-container-custom"]}>
                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("country")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className={`${classes['transparent-border']}${errors.includes('country') ? ` ${classes['error-border']}` : 'normal-border'}`}>
                      <CustomSelectComponent
                        isDisabled={false}
                        text={t("select_country")}
                        data={countryData}
                        OnChange={OnCountrySelectChange}
                        isSearchable={true}
                        label="name"
                        value="name"
                        position="bottom"
                        customPosition={true}
                        selectedValue={selectedCountry}
                      />
                    </div>

                    <div
                      className={
                        classes[
                          hasError("country")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_country")}
                    </div>
                  </div>

                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("state")}
                    </label>
                    {(selectedCountryId === "US" ||
                      selectedCountryId === "CA" ||
                      selectedCountryId === "BR") && (
                      <label style={{ color: "red", marginLeft: "3px" }}>
                        *
                      </label>
                    )}
                    <div className={`${classes['transparent-border']}${errors.includes('state') ? ` ${classes['error-border']}` : 'normal-border'}`}>
                      <CustomSelectComponent
                        isDisabled={stateData.length === 0 ? true : false}
                        text={
                          stateData.length === 0
                            ? t("not_applicable")
                            : t("select_state")
                        }
                        data={stateData}
                        OnChange={OnStateSelectChange}
                        isSearchable={true}
                        label="name"
                        value="name"
                        position="bottom"
                        customPosition={true}
                        selectedValue={selectedState}
                      />
                    </div>
                    <div
                      className={
                        classes[
                          hasError("state")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_state")}
                    </div>
                  </div>
                </div>

                <div className={classes["iiris-form-container-custom"]}>
                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("password")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className="iiris-input-group">
                      <input
                        type="password"
                        className="iiris-form-control"
                        name="password"
                        required="required"
                        ref={passwordInputRef}
                        onKeyUp={validatePassword}
                        onFocus={() => showHidePasswordRules()}
                        onBlur={() => showHidePasswordRules()}
                        style={{
                          ...(hasError("passwordInputRef") && {
                            borderColor: "red",
                          }),
                        }}
                      />
                      <i
                        style={{
                          position: "absolute",
                          right: "12px",
                          zIndex: 20,
                          cursor: "pointer",
                        }}
                        className="bi bi-eye-slash icon"
                        id="togglePassword"
                        onClick={showHidePassword}
                      ></i>
                    </div>
                    <div
                      className={
                        classes[
                          hasError("passwordInputRef")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_password")}
                    </div>
                  </div>
                  <div className={classes["iiris-form-group"]}>
                    <label className={classes["iiris-form-label"]}>
                      {t("confirm_password")}
                    </label>
                    <label style={{ color: "red", marginLeft: "3px" }}>*</label>
                    <div className="iiris-input-group">
                      <input
                        type="password"
                        className="iiris-form-control"
                        name="confirmPassword"
                        required="required"
                        ref={confirmPasswordInputRef}
                        onKeyUp={validatePassword}
                        onFocus={() => showHidePasswordRules()}
                        onBlur={() => showHidePasswordRules()}
                        style={{
                          ...(hasError("confirmPasswordInputRef") && {
                            borderColor: "red",
                          }),
                        }}
                      />
                      <i
                        style={{
                          position: "absolute",
                          right: "12px",
                          zIndex: 20,
                          cursor: "pointer",
                        }}
                        className="bi bi-eye-slash icon"
                        id="toggleConfirmPassword"
                        onClick={showHideConfirmPassword}
                      ></i>
                    </div>
                    <div
                      className={
                        classes[
                          hasError("confirmPasswordInputRef")
                            ? "iiris-error-space"
                            : "iiris-hidden"
                        ]
                      }
                    >
                      {t("please_confirm_password")}
                    </div>
                  </div>
                </div>

                <div className={classes["iiris-password-error-group"]}>
                  <div
                    className={
                      classes[
                        showPasswordRules === true
                          ? "iiris-passwordPopup"
                          : "iiris-hidden"
                      ]
                    }
                  >
                    <ul
                      style={{
                        columnCount: 1,
                        margin: "5px 0px 20px",
                        padding: "0px 0px",
                      }}
                    >
                      {mustContainData.map((data) => (
                        <MustContainItem
                          data={data}
                          showPasswordRules={showPasswordRules}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #E9E9E9",
                  borderRadius: "6px",
                  marginTop: "2rem",
                }}
              >
                <h4
                  style={{
                    borderBottom: "1px solid #E9E9E9",
                    padding: "0.65rem 1.3rem",
                  }}
                >
                  Business Details
                </h4>
                <div
                  className={classes["iiris-formItemsContainer"]}
                  style={{
                    gridTemplateRows: `repeat(1, 1fr)`,
                    gridTemplateColumns: `repeat(1, 1fr)`,
                    paddingTop:'16px'
                  }}
                >
                  {orderedQuestions.map((question, index, questions) => {
                    let profile_id = question.profile_id
                      ? question.profile_id
                      : question.id;
                    return (
                      <div
                        key={profile_id}
                        className={classes["iiris-form-container-custom"]}
                        style={{
                          gridColumnStart: Number(question.layout.cols),
                          gridColumnEnd:
                            questions[index + 1]?.layout?.rows ===
                            question.layout.rows
                              ? questions[index + 1].layout.cols
                              : Number(gridCols) + 1,
                          gridRowStart: Number(question.layout.rows),
                          gridRowEnd: Number(question.layout.rows) + 1,
                        }}
                      >
                        <div
                          className="iiris-form-group"
                          style={{ flexGrow: 1 }}
                        >
                          {question.type !== "checkbox" &&
                            ("render" in question ? question.render : true) && (
                              <label className={classes["iiris-form-label"]}>
                                {getQuestionTitle(question)}:
                              </label>
                            )}

                          {question.required === true &&
                            ("render" in question ? question.render : true) && (
                              <label
                                style={{ color: "red", marginLeft: "3px" }}
                              >
                                *
                              </label>
                            )}

                          {question.type === "chips" &&
                            !question.config
                              .filter(
                                (configObj) =>
                                  configObj.brand === brand &&
                                  configObj.division === division &&
                                  configObj.locale === language
                              )[0]
                              ?.hasOwnProperty("type") &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <div className={classes["iiris-chips"]}>
                                  <div className={classesMat.root}>
                                    {filteredQuestionData[
                                      `page${pageNumber}`
                                    ] &&
                                      filteredQuestionData[`page${pageNumber}`][
                                        profile_id
                                      ]?.map((bType) => (
                                        <Chip
                                          className={
                                            questionSelection[pageNumber - 1][
                                              `page${pageNumber}`
                                            ][index][profile_id] === bType.id
                                              ? classes["iiris-chipSelected"]
                                              : classes[""]
                                          }
                                          variant="outlined"
                                          size="large"
                                          icon={
                                            <Icon
                                              icon={bType.icon}
                                              color={bType.color}
                                              height="23"
                                              width="23"
                                            />
                                          }
                                          label={bType.name}
                                          onClick={() => {
                                            handleChipClick(
                                              profile_id,
                                              bType,
                                              index
                                            );
                                          }}
                                        />
                                      ))}
                                  </div>
                                </div>
                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_select")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </>
                            )}

                          {question.type === "multiselect-list" &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <div
                                  style={{
                                    border: "1px solid #ced4da",
                                    borderRadius: ".25rem",
                                  }}
                                >
                                  <div
                                    className={classes["iiris-list-container"]}
                                  >
                                    {filteredQuestionData[
                                      `page${pageNumber}`
                                    ] &&
                                      filteredQuestionData[`page${pageNumber}`][
                                        profile_id
                                      ]?.map((item, index) => (
                                        <div key={index}>
                                          <input
                                            value={item.id}
                                            type="checkbox"
                                            onChange={handleListCheck}
                                            checked={checkedListItems
                                              .map((item) => item.id)
                                              .includes(item.id)}
                                          />
                                          <span style={{ marginLeft: "10px" }}>
                                            {item.name}
                                          </span>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_select")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </>
                            )}
                          {question.type === "text" &&
                            profile_id !== "company" &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <input
                                  type="text"
                                  className={`iiris-form-control${errors.includes(profile_id) ? ` ${classes['error-border']}` : ' normal-border'}`}
                                  name={profile_id}
                                  maxlength="120"
                                  value={
                                    questionSelection[pageNumber - 1][
                                      `page${pageNumber}`
                                    ][index][profile_id]
                                  }
                                  onChange={(e) =>
                                    handleTextInputChange(
                                      profile_id,
                                      e.target.value,
                                      index
                                    )
                                  }
                                  style={{ fontSize: "14px" }}
                                />
                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_enter")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </>
                            )}

                          {question.type === "text" &&
                            profile_id === "company" &&
                            ("render" in question ? question.render : true) && (
                              <div className={classes["iiris-clearable-input"]}>
                                <TextInput
                                  value={
                                    questionSelection[pageNumber - 1][
                                      `page${pageNumber}`
                                    ][index][profile_id]
                                  }
                                  className={`iiris-form-control${errors.includes(profile_id) ? ` ${classes['error-border']}` : ' normal-border'}`}
                                  trigger=""
                                  Component="input"
                                  onChange={(val) =>
                                    handleTextInputChange(
                                      profile_id,
                                      val,
                                      index
                                    )
                                  }
                                />
                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_enter")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </div>
                            )}

                          {(question.type === "dropdown" ||
                            (question.config
                              ?.filter(
                                (configObj) =>
                                  configObj.brand === brand &&
                                  configObj.division === division &&
                                  configObj.locale === language
                              )[0]
                              ?.hasOwnProperty("type") &&
                              question.config.filter(
                                (configObj) =>
                                  configObj.brand === brand &&
                                  configObj.division === division &&
                                  configObj.locale === language
                              )[0].type === "dropdown")) &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <div className={`${classes['transparent-border']}${errors.includes(profile_id) ? ` ${classes['error-border']}` : 'normal-border'}`}>
                                  <CustomSelectComponent
                                    isDisabled={false}
                                    text={
                                      questionSelection[pageNumber - 1][
                                        `page${pageNumber}`
                                      ][index][profile_id]
                                    }
                                    data={
                                      filteredQuestionData[`page${pageNumber}`]
                                        ? filteredQuestionData[
                                            `page${pageNumber}`
                                          ][profile_id]
                                        : []
                                    }
                                    OnChange={(e) =>
                                      onDropdownChange(profile_id, e, index)
                                    }
                                    isSearchable={true}
                                    label="name"
                                    value="name"
                                    position="bottom"
                                    customPosition={false}
                                  />
                                </div>
                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_select")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </>
                            )}

                          {question.type === "checkbox" &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <input
                                  type="checkbox"
                                  className={classes["iiris-checkbox-style"]}
                                  onClick={(e) =>
                                    handleCheckboxChange(profile_id, e, index)
                                  }
                                />
                                <span>{getQuestionTitle(question)}</span>
                              </>
                            )}

                          {question.type === "radio-button" &&
                            ("render" in question ? question.render : true) && (
                              <>
                                <div>
                                  {filteredQuestionData[`page${pageNumber}`] &&
                                    filteredQuestionData[`page${pageNumber}`][
                                      profile_id
                                    ]?.map((item) => (
                                      <div>
                                        <input
                                          value={item.name}
                                          name="iris-radio-button-question"
                                          className={
                                            classes["iiris-form-label"]
                                          }
                                          type="radio"
                                          id={item.id}
                                          onClick={(e) =>
                                            handleRadioButton(
                                              profile_id,
                                              e,
                                              index
                                            )
                                          }
                                        />
                                        <label
                                          className="iiris-form-check-label"
                                          for={item.id}
                                        >
                                          {item.name}
                                        </label>
                                      </div>
                                    ))}
                                </div>

                                <div
                                  className={
                                    classes[
                                      hasError(profile_id)
                                        ? "iiris-error-space"
                                        : "iiris-hidden"
                                    ]
                                  }
                                >
                                  {t("please_select")}{" "}
                                  {getQuestionTitle(question).toLowerCase()}
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {pages.length > 1 && pageNumber !== 1 && (
                <div className="iiris-text-center">
                  <div className={classes["iiris-register-button-container"]}>
                    <button
                      className={`${classes["iiris-social-btn"]} iiris-btn iiris-btn-block `}
                      style={{
                        color: identityConfig.skin.skin_color,
                        background: identityConfig.skin.skin_background,
                      }}
                    >
                      Prev Page
                    </button>
                  </div>
                </div>
              )}

              {pages.length > 1 && pageNumber !== pages.length && (
                <div className="iiris-text-center">
                  <div className={classes["iiris-register-button-container"]}>
                    <button
                      className={`${classes["iiris-social-btn"]} iiris-btn iiris-btn-block `}
                      style={{
                        color: identityConfig.skin.skin_color,
                        background: identityConfig.skin.skin_background,
                      }}
                    >
                      Next Page
                    </button>
                  </div>
                </div>
              )}

              {countryType === "A" && (
                <div>
                  <div className={classes["iiris-formbox"]}>
                    <div className="iiris-input-group">
                      <p>{t("news_promotions")}</p>
                    </div>
                    <div className={classes["iiris-form-group"]}>
                      <div className="iiris-form-check iiris-form-check-inline">
                        <input
                          name="inlineRadioOptions1"
                          className="iiris-form-check-input"
                          type="radio"
                          id="inlineRadio11"
                          value="YES"
                          onClick={handleTypeASiteConsent}
                        />
                        <label
                          className="iiris-form-check-label"
                          for="inlineRadio11"
                        >
                          {t("yes")}
                        </label>
                      </div>
                      <div className="iiris-form-check iiris-form-check-inline">
                        <input
                          name="inlineRadioOptions1"
                          className="iiris-form-check-input"
                          type="radio"
                          id="inlineRadio12"
                          value="NO"
                          onClick={handleTypeASiteConsent}
                        />
                        <label
                          className="iiris-form-check-label"
                          for="inlineRadio12"
                        >
                          {t("no")}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      classes[
                        hasError("Aterms")
                          ? "iiris-error-space"
                          : "iiris-hidden"
                      ]
                    }
                  >
                    {t("please_consent")}
                  </div>
                </div>
              )}

              {(countryType === "B" || countryType === "C") && (
                <div>
                  <div className={classes["iiris-formbox"]}>
                    <label className={classes["iiris-checkbox-container"]}>
                      <input
                        type="checkbox"
                        className={classes["iiris-checkbox-style"]}
                        onClick={handleTypeBSiteConsent}
                      />
                      <span className={classes["iiris-checkmark"]}></span>
                      <span>{t("tick_here")}</span>
                      <strong> {t("do_not")}</strong>
                      <span> {t("want_to_receive")}</span>
                    </label>
                  </div>
                </div>
              )}
              {countryType === "D" && (
                <div>
                  <div className={classes["iiris-formbox"]}>
                    <div className="iiris-input-group">
                      <p>{t("by_continuing")}</p>
                    </div>
                  </div>
                </div>
              )}

              {countryType !== "" && (
                <div
                  style={{
                    width: "100%",
                    marginBottom: "0.8rem",
                  }}
                >
                  <div className={classes["iiris-formbox"]}>
                    <span>
                      {t("opt_out")}{" "}
                      <a
                        style={{
                          textDecoration: "underline",
                          color: "#0593FF",
                        }}
                        href="https://www.informa.com/privacy-policy/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <b>{t("privacy_policy")}</b>
                      </a>
                    </span>
                  </div>
                </div>
              )}

              <div
                style={{
                  width: "100%",
                  marginBottom: "0.8rem",
                }}
              >
                <div className={classes["iiris-formbox-terms-condn"]}>
                  <span>{t("terms_and_condition")}</span>
                  <a
												style={{ textDecoration: 'underline', color: '#0593FF' }}
												href='https://www.informa.com/privacy-policy/'
												target='_blank'
												rel='noreferrer'
											>
												<b>{t('privacy_policy')}</b>
											</a>
                </div>
              </div>

              {identityConfig.captcha && (
                <div className={classes["iiris-g-recaptcha"]}>
                  {identityConfig.captcha_type === "recaptcha" && (
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={google_captcha_key}
                      onloadCallback={onCaptchaLoad}
                      onChange={verifyCaptcha}
                      onExpired={expireCaptcha}
                      type="image"
                      hl={identityConfig.language}
                    />
                  )}
                  {identityConfig.captcha_type === "hcaptcha" && (
                    <HCaptcha
                      ref={hcaptchaRef}
                      sitekey={hcaptcha_key}
                      onLoad={onCaptchaLoad}
                      onVerify={verifyCaptcha}
                      onError={onError}
                      onExpire={expireCaptcha}
                    />
                  )}
                  <div
                    className={
                      classes[
                        hasError("captcha")
                          ? "iiris-error-space"
                          : "iiris-hidden"
                      ]
                    }
                  >
                    {t("please_captcha")}
                  </div>
                </div>
              )}

              <div className="iiris-btn-center">
                <button
                  onClick={signUpWithEmail}
                  type="button"
                  className={`${classes["iiris-social-btn"]} iiris-btn ${classes["iiris-btn-block"]} `}
                  style={{
                    color: identityConfig.skin.skin_color,
                    background: identityConfig.skin.skin_background,
                  }}
                >
                  {t("sign_up_email")}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
};
